import { render, staticRenderFns } from "./closeZone.vue?vue&type=template&id=9f47e796&scoped=true"
import script from "./closeZone.vue?vue&type=script&lang=js"
export * from "./closeZone.vue?vue&type=script&lang=js"
import style0 from "./closeZone.vue?vue&type=style&index=0&id=9f47e796&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f47e796",
  null
  
)

export default component.exports